import type { FC } from "react";
import type { TimelineItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { TimelineItemLayout } from "web_myplann/NotificationCenter/Components/TimelineItemLayout";
import { useTimelineEntryDateLines } from "web_myplann/NotificationCenter/Hooks/useTimelineEntryDateLines";
import { TimelineDateStyle } from "web_myplann/NotificationCenter/Types/TimelineDateStyle";
import { TimelineRowVariant } from "web_myplann/NotificationCenter/Types/TimelineRowVariant";

interface ResolvingNowItemProps {
	item: TimelineItemResponseDTO;
	onClick?: (item: TimelineItemResponseDTO) => void;
	isLast?: boolean;
}

// Unlike the timeline buckets, "ResolvingNow" has no heading stating the day,
// so each row carries the full date. The time goes on a second line to keep
// the date column from crowding out the title.
export const ResolvingNowItem: FC<ResolvingNowItemProps> = ({
	item,
	onClick,
	isLast = false,
}) => {
	const { dateLine, secondaryDateLine } = useTimelineEntryDateLines(
		item,
		TimelineDateStyle.Absolute,
	);

	return (
		<TimelineItemLayout
			item={item}
			dateLine={dateLine}
			secondaryDateLine={secondaryDateLine}
			showChevron={!!onClick}
			disabled={!onClick}
			onClick={onClick ? () => onClick(item) : undefined}
			isLast={isLast}
			variant={TimelineRowVariant.Task}
			data-testid={`resolving-now-item-${item.id}`}
		/>
	);
};
